import * as CR from '../services/clients';
import { helpers } from '../utils';

export const ACTION_CLIENTS_LOADLIST = 'clients/loadList';
export const ACTION_CLIENTS_LOAD_ITEM = 'clients/loadItem';
export const ACTION_CLIENTS_CREATE = 'clients/create';
export const ACTION_CLIENTS_UPDATE = 'clients/update';
export const ACTION_CLIENTS_DELETE = 'clients/remove';
export const ACTION_CLIENTS_LOAD_RECOGNITION_USAGES = 'clients/loadRecognitionUsages';

export default {
  namespace: 'clients',
  state: {
    clientsFullList: [],
  },

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    * loadList({ payload }, { call, put }) {
      try {
        const response = yield call(CR.clientsListRequest, payload);

        yield put({
          type: 'updateStore',
          payload: {
            clientsFullList: response.data,
          },
        });

        return response;
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call }) {
      try {
        return yield call(CR.clientsItemRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadRecognitionUsages({ payload: { id } }, { call }) {
      try {
        const response = yield call(CR.clientsRecognitionUsagesRequest, { id });

        return response.body;
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadDefault({ payload }, { call }) {
      try {
        return yield call(CR.clientsDefaultRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create(
      {
        payload: { data },
      },
      { call },
    ) {
      try {
        return yield call(CR.clientsCreateRequest, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update(
      {
        payload: { id, data },
      },
      { call },
    ) {
      try {
        return yield call(CR.clientsUpdateRequest, { id }, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove({ payload: { id } }, { call, put }) {
      try {
        yield call(CR.clientsDeleteRequest, { id });

        yield put({
          type: 'app/addNotification',
          payload: {
            type: 'success',
            message: 'Common.Success',
            description: 'Component.Administration.Clients.Remove.Success.Text',
          },
        });

        return true;
      } catch (e) {
        helpers.processException(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/clients.js